<template>
  <div>
    <base-header class="pb-6 pb-4 pt-5 pt-md-8" type="purple">
      <!-- Card stats -->
      <b-row>
        <b-col xl="3" md="6">
          <stats-card
            title="Agências"
            type="danger"
            :sub-title="dashboardData.publicitarios.toString()"
            icon="ni ni-building"
            class="mb-4"
            v-loading="loading"
          >
            <template slot="footer">
              <h5 class="card-title text-uppercase text-muted mb-0">
                Peças Publicitárias
              </h5>
              <span class="h3 font-weight-bold mb-0">
                {{ dashboardData.pecasPublicitarias }}
              </span>
              <div class="d-flex justify-content-end">
                <router-link to="/admin/agencias" class="mx-2">
                  <base-button size="sm" type="danger">
                    Ver Agências
                  </base-button>
                </router-link>

                <router-link to="/admin/pecas-publicitarias">
                  <base-button size="sm" type="danger">Ver Peças</base-button>
                </router-link>
              </div>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card
            title="Estudantes"
            type="info"
            :sub-title="dashboardData.estudantes.toString()"
            icon="ni ni-hat-3"
            class="mb-4"
            v-loading="loading"
          >
            <template slot="footer">
              <h5 class="card-title text-uppercase text-muted mb-0">
                Peças de Estudantes
              </h5>
              <span class="h3 font-weight-bold mb-0">
                {{ dashboardData.pecaEstudantes }}
              </span>
              <div class="d-flex justify-content-end">
                <router-link to="/admin/estudantes" class="mx-2">
                  <base-button size="sm" type="info">
                    Ver Estudantes
                  </base-button>
                </router-link>
                <router-link to="/admin/pecas-estudantes" class="mx-2">
                  <base-button size="sm" type="info">Ver Peças</base-button>
                </router-link>
              </div>
            </template>
          </stats-card>
        </b-col>
      </b-row>
      <h2 class="text-white">Legado:</h2>
      <b-row>
        <b-col xl="3" md="6">
          <stats-card
            title="Fornecedores"
            type="warning"
            :sub-title="dashboardData.fornecedores.toString()"
            icon="ni ni-bag-17"
            class="mb-4"
            v-loading="loading"
          >
            <template slot="footer">
              <h5 class="card-title text-uppercase text-muted mb-0">
                Peças de Fornecedores
              </h5>
              <span class="h3 font-weight-bold mb-0">
                {{ dashboardData.pecaFornecedores }}
              </span>
              <div class="d-flex justify-content-end">
                <router-link to="/admin/fornecedores" class="mx-2">
                  <base-button size="sm" type="warning">
                    Ver Fornecedores
                  </base-button>
                </router-link>
                <router-link to="/admin/pecas-fornecedores" class="mx-2">
                  <base-button size="sm" type="warning">Ver Peças</base-button>
                </router-link>
              </div>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card
            title="Profissionais"
            type="success"
            :sub-title="
              dashboardData.profissionais +
              (dashboardData.profissionais == 1 ? ' indicação' : ' indicações')
            "
            icon="ni ni-briefcase-24"
            class="mb-4"
            v-loading="loading"
          >
            <template slot="footer">
              <div class="mt-4 d-flex justify-content-end">
                <router-link to="/admin/profissionais" class="mx-2">
                  <base-button size="sm" type="success">
                    Ver indicações
                  </base-button>
                </router-link>
              </div>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="5" md="12">
          <stats-card
            title="Profissional Independente"
            type="success"
            :sub-title="dashboardData.profissionaisIndependentes.toString()"
            icon="ni ni-briefcase-24"
            class="mb-4"
            v-loading="loading"
          >
            <template slot="footer">
              <h5 class="card-title text-uppercase text-muted mb-0">
                Peças de Profissionais Independentes
              </h5>
              <span class="h3 font-weight-bold mb-0">
                {{ dashboardData.pecasProfissionalIndependente }}
              </span>
              <div class="d-flex justify-content-end">
                <router-link to="/admin/profissional-independente" class="mx-2">
                  <base-button size="sm" type="success">
                    Ver Profissionais Independente
                  </base-button>
                </router-link>
                <router-link
                  to="/admin/pecas-profissional-independente"
                  class="mx-2"
                >
                  <base-button size="sm" type="success">Ver Peças</base-button>
                </router-link>
              </div>
            </template>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>

    <!--Charts-->
    <!-- <b-container fluid class="mt--7">
      <b-row class="mt-5">
        <b-col xl="6" class="mb-5 mb-xl-0">
          <categoria-table
            title="Categoria - Peça Publicitárias"
          ></categoria-table>
        </b-col>
        <b-col xl="6" class="mb-5 mb-xl-0">
          <categoria-table
            title="Categoria - Peça Fornecedores"
          ></categoria-table>
        </b-col>
      </b-row>
    </b-container> -->
  </div>
</template>
<script>
import api from "@/services/api";
// Components
import StatsCard from "@/components/Cards/StatsCard";

// Tables
//import CategoriaTable from "./CategoriaTable";

export default {
  components: {
    StatsCard,
    //CategoriaTable,
  },
  data() {
    return {
      loading: false,
      dashboardData: {
        publicitarios: 0,
        pecasPublicitarias: 0,
        estudantes: 0,
        pecaEstudantes: 0,
        fornecedores: 0,
        pecaFornecedores: 0,
        profissionais: 0,
      },
    };
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const response = await api.get("analytics");
        this.dashboardData = response.data;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.load();
  },
};
</script>
